import { Navigate } from "@solidjs/router";

export default function Index() {
  return <Navigate href="/home" />;
}
